import { createTracker } from 'usage-tracker';
const NAMESPACE = 'Customer Data Properties';
const EVENT_NAMES = {
  INTERACTION: 'Interaction',
  PAGEVIEW: 'Pageview'
};
export const usageTracker = createTracker({
  standalone: true
});
export const standaloneUsageTracker = createTracker({
  standalone: true,
  properties: {
    screen: 'customer-data-properties'
  }
});
export const trackConditionalPropertiesPanelSubmit = () => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: `customer-data-properties`,
    subscreen: `conditional-properties-panel`,
    action: 'submit'
  });
};
export const trackAutosaveSuccess = ({
  identifiers,
  objectTypeId
}) => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: `customer-data-properties`,
    action: 'autosave success',
    type: 'PROPERTY',
    objectTypeId,
    propertyNames: identifiers
  });
};
export const trackAutosaveUndo = ({
  identifiers,
  objectTypeId
}) => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: `customer-data-properties`,
    action: 'autosave undo',
    type: 'PROPERTY',
    propertyNames: identifiers,
    objectTypeId
  });
};
export const trackShowHighlySensitiveValueClick = ({
  propertyName,
  objectTypeId
}) => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: `customer-data-properties`,
    propertyName,
    objectTypeId,
    action: 'show highly sensitive value'
  });
};
export const trackRejectedReviveDealSubmit = () => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: `customer-data-properties`,
    action: 'revive rejected deal'
  });
};
export const logPageView = payload => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.PAGEVIEW, Object.assign({}, payload, {
    screen: `customer-data-properties`
  }));
};
export const trackExpandableTextCollapse = ({
  component,
  propertyName,
  objectTypeId
}) => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: `customer-data-properties`,
    subscreen: component,
    action: 'expandable text collapse',
    propertyName,
    objectTypeId
  });
};
export const trackExpandableTextExpand = ({
  component,
  propertyName,
  objectTypeId
}) => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: `customer-data-properties`,
    subscreen: component,
    action: 'expandable text expand',
    propertyName,
    objectTypeId
  });
};
export const trackDetailsLinkButtonClick = ({
  propertyName,
  objectTypeId,
  type
}) => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: `customer-data-properties`,
    action: 'details link button click',
    type,
    propertyName,
    objectTypeId
  });
};
export const trackDocumentationLinkButtonClick = ({
  propertyName,
  objectTypeId
}) => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: `customer-data-properties`,
    action: 'property documentation link button click',
    propertyName,
    objectTypeId
  });
};
export const trackFormattedPropertyPhoneClick = ({
  objectTypeId
}) => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: 'customer-data-properties',
    action: 'initiate call',
    objectTypeId
  });
};
export const trackContextMenuOpened = ({
  propertyName,
  objectTypeId
}) => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: 'customer-data-properties',
    subscreen: 'context-menu',
    action: 'context menu opened',
    propertyName,
    objectTypeId
  });
};
export const trackHoverActionClick = ({
  key,
  type,
  propertyName,
  objectTypeId
}) => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: 'customer-data-properties',
    subscreen: 'hover-content',
    action: 'hover action click',
    key,
    type,
    propertyName,
    objectTypeId
  });
};
export const trackContextMenuItemClick = ({
  key,
  type,
  propertyName,
  objectTypeId
}) => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: 'customer-data-properties',
    subscreen: 'context-menu',
    action: 'context menu item click',
    key,
    type,
    propertyName,
    objectTypeId
  });
};
export const trackPropertyValueLinkClick = ({
  key,
  propertyName,
  objectTypeId,
  propertyType,
  fieldType
}) => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: 'customer-data-properties',
    action: 'property value link click',
    key,
    propertyName,
    objectTypeId,
    propertyType,
    fieldType
  });
};
export const trackCommunicationLinkClick = ({
  propertyName,
  objectTypeId
}) => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: 'customer-data-properties',
    action: 'communication link click',
    propertyName,
    objectTypeId
  });
};
export const trackPropertyOptionDescriptionHover = ({
  propertyName,
  objectTypeId
}) => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: 'customer-data-properties',
    subscreen: 'property-option-description',
    action: 'option description hover',
    propertyName,
    objectTypeId
  });
};
export const trackFollowUpPopoverOpened = ({
  objectTypeId
}) => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: 'customer-data-properties',
    subscreen: 'follow-up-cell',
    action: 'follow-up-popover-opened',
    objectTypeId
  });
};
export const trackFollowUpReviewClicked = ({
  objectTypeId
}) => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: 'customer-data-properties',
    subscreen: 'follow-up-cell',
    action: 'follow-up-review-clicked',
    objectTypeId
  });
};
export const trackFollowUpDismissed = ({
  objectTypeId
}) => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: 'customer-data-properties',
    subscreen: 'follow-up-cell',
    action: 'follow-up-dismissed',
    objectTypeId
  });
};

// Smart Data Capture
export const trackSuggestionBadgeClicked = ({
  entryPoint = 'DeferredPropertyInput',
  objectTypeId,
  propertyName,
  propertyType
}) => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    action: 'sdc property suggestion badge clicked',
    entryPoint,
    objectTypeId,
    propertyName,
    propertyType
  });
};
export const trackSuggestionDecision = ({
  action,
  changesMade,
  entryPoint = 'DeferredPropertyInput',
  objectId,
  objectTypeId,
  propertyName,
  propertyType
}) => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    action,
    changesMade,
    count: '1',
    entryPoint,
    objectId,
    objectTypeId,
    propertyName,
    propertyType
  });
};